import styled from 'styled-components';

interface DotProps {
  color?: string;
  colorFuture?: string;
  active: boolean;
  opacity: number;
}

export const Dot = styled('span')<DotProps>`
  opacity: ${({ opacity }) => opacity};
  &:before {
    content: '';
    display: inline-block;
    width: ${({ theme }) => theme.x1spacePx}px;
    height: ${({ theme }) => theme.x1spacePx}px;
    border-radius: ${({ theme }) => theme.x1spacePx}px;
    box-shadow: inset 0 0 1px 1px ${({ color }) => color || 'white'};
    background: ${({ color, active, theme }) =>
      active ? color || 'white' : theme.color.charcoal};
    margin-right: -${({ theme }) => theme.x1spacePx / 4}px;
  }
  &:after {
    content: '';
    display: inline-block;
    width: ${({ theme }) => theme.x1spacePx}px;
    height: ${({ theme }) => theme.x1spacePx}px;
    border-radius: ${({ theme }) => theme.x1spacePx}px;
    box-shadow: inset 0 0 1px 1px ${({ colorFuture }) => colorFuture || 'white'};
    background: ${({ colorFuture, active, theme }) =>
      active ? colorFuture || 'white' : theme.color.charcoal};
    margin-right: ${({ theme }) => theme.x1spacePx}px;
  }
`;

export const DataTableWrapper = styled('div')`
  & table {
    // Prevent the table from overflowing when its content is larger than its container
    table-layout: fixed;
  }

  // wrap text contents in table cells
  & table th {
    white-space: pre-wrap;
  }

  & table td {
    word-wrap: break-word;
    white-space: break-spaces;
  }
`;
